<template>  
  <div>  
    <input ref="myInput" type="text" />  
	<input ref="myInput2" type="text" />
	<input ref="myInput3" type="text" />
	

<input ref="myInput4" type="text" />
<button @click="focusOnInput">Focus on the input</button>  
  </div>  
</template>  
  
<script>  
export default {  
  methods: {  
    focusOnInput() {  
      // 使用 this.$refs['myInput'] 来访问 input 元素  
      this.$refs.myInput4.focus();  
    }  
  }  
}  
</script>
